// @flow

import React, { PureComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { i18n, Analytics } from 'shared/utils';
import * as Actions from 'main-app/store/Actions';
import DeleteCustomerMutation from 'main-app/mutations/DeleteCustomer';
import Button from 'shared/components/common/Button';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'shared/components/modal';
import type { DeleteCustomerModal_customer as CustomerFragment } from './__generated__/DeleteCustomerModal_customer';

type Props = {
  onClose: () => void,
  onSuccess?: () => void,
  customer: CustomerFragment,
};

type State = {
  deleting: boolean,
};

class DeleteCustomerModal extends PureComponent<Props, State> {
  state = {
    deleting: false,
  };

  static defaultProps = {
    onSuccess: undefined,
  };

  handleDelete = () => {
    const { customer, onClose, onSuccess } = this.props;

    this.setState(
      {
        deleting: true,
      },
      async () => {
        try {
          await DeleteCustomerMutation.commit({
            variables: {
              input: {
                id: customer.id,
              },
            },
          });

          onClose();

          if (onSuccess) {
            onSuccess();
          }

          Analytics.trackEvent('Delete Customer', {
            customerName: customer.name,
            customerId: customer.id,
          });
          Actions.alertNotification(
            i18n.t(`Customer Successfully Deleted`),
            'success',
          );
        } catch (e) {
          this.setState({ deleting: false });

          Actions.alertNotification(e.message, 'error');
        }
      },
    );
  };

  render() {
    const { deleting } = this.state;
    const { customer, onClose } = this.props;

    return (
      <Modal maxWidth={700}>
        <ModalHeader
          header={i18n.t('Delete Customer: {{customerName}}?', {
            customerName: customer.name,
          })}
          onClose={onClose}
        />
        <ModalBody withPadding>
          {i18n.t(
            `You will not be able to access this customer profile again upon deletion.`,
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            theme="border-white"
            loading={deleting}
            onClick={this.handleDelete}
          >
            {i18n.t('Yes, Delete Customer')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createFragmentContainer(DeleteCustomerModal, {
  customer: graphql`
    fragment DeleteCustomerModal_customer on Customer {
      id
      name
    }
  `,
});
